export default {
  name: "step",
  props: ["name", "icon", "id", "currentStep"],
  computed: {
    isActive() {
      return this.id === this.currentStep;
    },

    isPass() {
      return this.id < this.currentStep;
    }
  }
};
